import { download } from "./api";
import { errorText } from "../components/ui";
import { viewExport } from "../components/ExportViewer";
import type { T } from "./i18n";

type Toast = (t: { text: string; tone?: "bad" | "warn"; action?: { label: string; run: () => void } }) => void;

/**
 * Every export opens on screen first — readable on any phone, no Excel app needed — with "Save Excel" there to
 * keep or send the file.
 */
export function exportFile(url: string, name: string) {
  viewExport(url, name);
}

/** Straight to the file: when it fails, the person is told why and gets "Try again" right there. */
export async function saveExport(t: T, toast: Toast, url: string, name: string) {
  try {
    await download(url, name);
  } catch (e) {
    toast({ text: errorText(t, e), tone: "bad", action: { label: t("common.retry"), run: () => void saveExport(t, toast, url, name) } });
  }
}
